import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { OptionIcon } from "./OptionIcon";

const cardMotion = {
    initial: { opacity: 0, y: 10 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.35, ease: [0.2, 0.8, 0.2, 1] },
};

const iconSpring = {
    selected: {
        scale: [1, 1.3, 1],
        transition: {
            duration: 0.45,
            times: [0, 0.55, 1],
            ease: [0.34, 1.56, 0.64, 1],
        },
    },
    idle: { scale: 1 },
};

export function CardSelect({ options, value, onChange, name }) {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <AnimatePresence initial={false}>
                {options.map((opt, i) => {
                    const selected = value === opt.value;
                    return (
                        <motion.button
                            key={opt.value}
                            type="button"
                            role="radio"
                            aria-checked={selected}
                            onClick={() => onChange(opt.value)}
                            data-testid={`option-${name}-${opt.value}`}
                            {...cardMotion}
                            transition={{
                                ...cardMotion.transition,
                                delay: i * 0.04,
                            }}
                            whileHover={{ y: -2 }}
                            whileTap={{ scale: 0.985 }}
                            className={`text-left p-5 rounded-2xl border transition-[background-color,border-color,box-shadow] duration-300 ease-out focus-visible:outline-none
                                ${
                                    selected
                                        ? "border-klareet-T bg-klareet-T/10 shadow-[0_10px_40px_-12px_rgba(13,148,136,0.35)]"
                                        : "border-klareet-bor bg-klareet-card hover:border-klareet-T/60 hover:bg-white/[0.03]"
                                }`}
                        >
                            <div className="flex items-start gap-4">
                                <motion.div
                                    className="shrink-0 mt-0.5"
                                    variants={iconSpring}
                                    animate={selected ? "selected" : "idle"}
                                >
                                    <OptionIcon
                                        name={opt.icon}
                                        selected={selected}
                                    />
                                </motion.div>
                                <div className="min-w-0">
                                    <div
                                        className={`text-[15px] font-semibold tracking-tight transition-colors duration-300 ${
                                            selected
                                                ? "text-klareet-T2"
                                                : "text-klareet-TEXT"
                                        }`}
                                    >
                                        {opt.title}
                                    </div>
                                    {opt.sub ? (
                                        <div className="mt-1 text-sm text-klareet-MUT leading-snug">
                                            {opt.sub}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </motion.button>
                    );
                })}
            </AnimatePresence>
        </div>
    );
}
